import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import DropletIcons from '@components/products/DropletIcons';
import { Typography, TextVariant } from '@components/shared/design/Typography';
import { PAD_BIG_ICONS, PAD_BLOOD_DROPLET_COUNTS } from '@constants';
import { getAllPadTypes, getPadTypeLongTextByType } from '@utils/pads';

const PadSizeGrid: React.FC = () => {
  const { t } = useTranslation();
  const padSizes = getAllPadTypes();

  return (
    <GridWrap>
      {padSizes.map((padSize) => {
        const headingLong = t(getPadTypeLongTextByType(padSize));

        return (
          <GridSlide key={padSize}>
            <Inner>
              <ItemImageWrap>
                <img src={PAD_BIG_ICONS[padSize]} alt={headingLong} />
              </ItemImageWrap>
              <ItemDetails>
                <DropletIcons dropsCount={PAD_BLOOD_DROPLET_COUNTS[padSize]} />
                <Typography $variant={TextVariant.BodyBoldMD} $mobileVariant={TextVariant.BodyBoldSM}>
                  {headingLong}
                </Typography>
              </ItemDetails>
            </Inner>
          </GridSlide>
        );
      })}
    </GridWrap>
  );
};

export default PadSizeGrid;

const GridWrap = styled.div`
  max-width: 460px;
  display: flex;
  justify-content: space-between;
  padding-right: 16px;
`;

const GridSlide = styled.div``;

const Inner = styled.div`
  max-width: 100%;
  text-align: -webkit-center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 14px;
`;

const ItemImageWrap = styled.div`
  height: 116px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 100%;
  }
`;

const ItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;
